module.exports = __webpack_public_path__ + "src/assets/img/chip-100.43166a81.svg";